/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
	  };
import type * as Types from '../../../../../gql/types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetArtistPageTalksQueryVariables = Exact<{
	filter?: Types.Artists_Filter | null | undefined;
	limit?: number | null | undefined;
	offset?: number | null | undefined;
	page?: number | null | undefined;
	search?: string | null | undefined;
	sort?: Array<string | null | undefined> | string | null | undefined;
}>;

export type GetArtistPageTalksQuery = {
	Artists: Array<{
		talks: Array<{
			HENI_Talks_Talks_id: {
				title: string;
				video_duration: string | null;
				short_description: string | null;
				slug: string | null;
				featured_image: { filename_disk: string | null } | null;
			} | null;
		} | null> | null;
	}>;
};

export const GetArtistPageTalksDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'getArtistPageTalks' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'filter' },
					},
					type: {
						kind: 'NamedType',
						name: { kind: 'Name', value: 'Artists_filter' },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'limit' },
					},
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'offset' },
					},
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'search' },
					},
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
					type: {
						kind: 'ListType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'String' },
						},
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'Artists' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'filter' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'filter' },
								},
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'page' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'page' },
								},
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'search' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'search' },
								},
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'talks' },
									arguments: [
										{
											kind: 'Argument',
											name: { kind: 'Name', value: 'limit' },
											value: {
												kind: 'Variable',
												name: { kind: 'Name', value: 'limit' },
											},
										},
										{
											kind: 'Argument',
											name: { kind: 'Name', value: 'offset' },
											value: {
												kind: 'Variable',
												name: { kind: 'Name', value: 'offset' },
											},
										},
										{
											kind: 'Argument',
											name: { kind: 'Name', value: 'sort' },
											value: {
												kind: 'Variable',
												name: { kind: 'Name', value: 'sort' },
											},
										},
									],
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'HENI_Talks_Talks_id' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'title' },
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'video_duration' },
														},
														{
															kind: 'Field',
															name: {
																kind: 'Name',
																value: 'short_description',
															},
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'slug' },
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'featured_image' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'filename_disk',
																		},
																	},
																],
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetArtistPageTalksQuery,
	GetArtistPageTalksQueryVariables
>;
